module.exports = __webpack_public_path__ + "img/xmh-logo.be5637d7.png";